module.exports={
	"Form": "CoreCreateManifest",
	"Scope": "Core-Create",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Core-Create-Identity",
				"Group": "Core-Create-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-Create-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-Create-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-Create-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-Create-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
